module.exports = __webpack_public_path__ + "static/media/icon_marker_white.8a892f47.svg";